import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import type { RoomTypeModel } from 'types/api'
import { BaseResponse } from 'types/utils'

export function useDataForRoom() {
  async function fetchFlats() {
    const roomTypes = await apiClient.get<BaseResponse<RoomTypeModel>>(
      `${SNA_PREFIX}room-types`
    )
    return roomTypes.data
  }

  return useQuery({
    queryKey: ['rooms'],
    queryFn: fetchFlats
  })
}
